import { DrawerBody, DrawerHeader, DrawerHeaderTitle, OverlayDrawer, makeStyles } from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import { useEffect } from "react";
import { FuiButton } from "@/components/fui-control";
import { Inspector } from "@/features/inspector/Inspector";
import { useProjectStore } from "@/store/project-store";

const useStyles = makeStyles({
  drawer: {
    width: "400px",
    maxWidth: "100vw",
  },
  body: {
    height: "calc(100vh - 48px)",
    overflow: "hidden",
    padding: 0,
  },
});

/** 문서 위에 여는 일정 상세. 간트 화면의 인스펙터와 같은 내용이다. */
export function SchedulePeekDrawer() {
  const styles = useStyles();
  const id = useProjectStore((s) => s.schedulePeekId);
  const alive = useProjectStore((s) => (id ? s.project.tasks.some((task) => task.id === id) : false));

  useEffect(() => {
    if (id && !alive) useProjectStore.getState().setSchedulePeek(null);
  }, [id, alive]);

  if (!id || !alive) return null;
  return (
    <OverlayDrawer
      open
      position="end"
      modalType="modal"
      className={styles.drawer}
      onOpenChange={(_, data) => {
        if (!data.open) useProjectStore.getState().setSchedulePeek(null);
      }}
      aria-label="일정"
    >
      <DrawerHeader>
        <DrawerHeaderTitle
          action={
            <FuiButton appearance="subtle" icon={<Dismiss24Regular />} aria-label="닫기" onClick={() => useProjectStore.getState().setSchedulePeek(null)} />
          }
        >
          일정
        </DrawerHeaderTitle>
      </DrawerHeader>
      <DrawerBody className={styles.body}>
        <Inspector taskId={id} />
      </DrawerBody>
    </OverlayDrawer>
  );
}
